export function parseLineBreak(text) {
  return text?.replace(/(?:\r\n|\r|\n)/g, '<br/>');
}
